export default __webpack_public_path__ + "static/artwork-2-1a100e5249a81cccda83d33e4521240b.png";